<template>
  <div>
    <v-tabs v-model="activeTab" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab active-class="tab" :key="1" ripple> {{ $t("ridesListPage.statusPending") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <v-data-table
          :headers="headers"
          :items="pendingComplaints"
          :loading="loading"
          :pagination.sync="pendingPagination"
          :total-items="pendingTotal"
          :rows-per-page-items="[10, 25, 50, 100]"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                <a @click="goToBooking(getBookingId(props.item))" class="booking-link" v-if="getBookingId(props.item)">
                  #{{ getBookingId(props.item) }}
                </a>
                <span v-else>-</span>
              </td>
              <td>{{ props.item.description }}</td>
              <td class="text-xs-center">
                {{ formatDate(props.item.created_at) }}
              </td>
              <td class="text-xs-center">
                <span v-if="props.item.creator">
                  {{ props.item.creator.first_name }} {{ props.item.creator.last_name }}
                </span>
                <span v-else>-</span>
              </td>
              <td class="text-xs-center">
                <v-btn
                  color="success"
                  small
                  @click="openResolveDialog(props.item)"
                >
                  {{ $t("ridesListPage.resolve") }}
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="2" ripple> {{ $t("ridesListPage.resolved") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <v-data-table
          :headers="resolvedHeaders"
          :items="resolvedComplaints"
          :loading="loading"
          :pagination.sync="resolvedPagination"
          :total-items="resolvedTotal"
          :rows-per-page-items="[10, 25, 50, 100]"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                <a @click="goToBooking(getBookingId(props.item))" class="booking-link" v-if="getBookingId(props.item)">
                  #{{ getBookingId(props.item) }}
                </a>
                <span v-else>-</span>
              </td>
              <td>{{ props.item.description }}</td>
              <td class="text-xs-center">
                {{ formatDate(props.item.created_at) }}
              </td>
              <td class="text-xs-center">
                <span v-if="props.item.creator">
                  {{ props.item.creator.first_name }} {{ props.item.creator.last_name }}
                </span>
                <span v-else>-</span>
              </td>
              <td class="text-xs-center">
                {{ formatDate(props.item.resolved_at) }}
              </td>
              <td class="text-xs-center">
                <span v-if="props.item.resolver">
                  {{ props.item.resolver.first_name }} {{ props.item.resolver.last_name }}
                </span>
                <span v-else>-</span>
              </td>
              <td>{{ props.item.resolution_comment || '-' }}</td>
            </tr>
          </template>
        </v-data-table>
        </div>
      </v-tab-item>
    </v-tabs>
    
    <!-- Resolve Complaint Dialog -->
    <v-dialog v-model="resolveDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("ridesListPage.resolveComplaint") }}</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="resolutionComment"
            :label='$t("ridesListPage.resolutionCommentLabel")'
            :placeholder='$t("ridesListPage.resolutionCommentPlaceholder")'
            rows="4"
            outlined
            auto-grow
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeResolveDialog" :disabled="resolvingComplaint">
            {{ $t("ridesListPage.cancel") }}
          </v-btn>
          <v-btn
            color="success"
            @click="resolveComplaint"
            :loading="resolvingComplaint"
          >
            {{ $t("ridesListPage.resolve") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "BookingComplaints",
  title: "ridesListPage.complaintsTitle",
  data() {
    return {
      activeTab: 0,
      loading: false,
      pendingComplaints: [],
      resolvedComplaints: [],
      pendingPagination: {
        page: 1,
        rowsPerPage: 25
      },
      resolvedPagination: {
        page: 1,
        rowsPerPage: 25
      },
      pendingTotal: 0,
      resolvedTotal: 0,
      resolveDialog: false,
      selectedComplaint: null,
      resolutionComment: "",
      resolvingComplaint: false
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("ridesListPage.colBookingId"), value: "booking_id", align: "center", sortable: false },
        { text: this.$t("ridesListPage.colDescription"), value: "description", sortable: false },
        { text: this.$t("ridesListPage.colCreatedAt"), value: "created_at", align: "center", sortable: false },
        { text: this.$t("ridesListPage.colCreatedBy"), value: "created_by", align: "center", sortable: false },
        { text: this.$t("ridesListPage.colActions"), value: "actions", align: "center", sortable: false }
      ];
    },
    resolvedHeaders() {
      return [
        { text: this.$t("ridesListPage.colBookingId"), value: "booking_id", align: "center", sortable: false },
        { text: this.$t("ridesListPage.colDescription"), value: "description", sortable: false },
        { text: this.$t("ridesListPage.colCreatedAt"), value: "created_at", align: "center", sortable: false },
        { text: this.$t("ridesListPage.colCreatedBy"), value: "created_by", align: "center", sortable: false },
        { text: this.$t("ridesListPage.colResolvedAt"), value: "resolved_at", align: "center", sortable: false },
        { text: this.$t("ridesListPage.colResolvedBy"), value: "resolved_by", align: "center", sortable: false },
        { text: this.$t("ridesListPage.colResolution"), value: "resolution_comment", sortable: false }
      ];
    }
  },
  watch: {
    activeTab() {
      if (this.activeTab === 0) {
        this.fetchPendingComplaints();
      } else {
        this.fetchResolvedComplaints();
      }
    },
    pendingPagination: {
      handler() {
        this.fetchPendingComplaints();
      },
      deep: true
    },
    resolvedPagination: {
      handler() {
        this.fetchResolvedComplaints();
      },
      deep: true
    }
  },
  mounted() {
    this.fetchPendingComplaints();
  },
  methods: {
    fetchPendingComplaints() {
      this.loading = true;
      const params = {
        status: "PENDING",
        page: this.pendingPagination.page,
        perPage: this.pendingPagination.rowsPerPage
      };
      
      axios
        .get("booking-complaints", { params })
        .then((res) => {
          this.pendingComplaints = res.data.data.data || [];
          this.pendingTotal = res.data.data.total || 0;
        })
        .catch((err) => {
          console.error("Error fetching pending complaints:", err);
          window.getApp.$emit("SHOW_TOAST", this.$t("ridesListPage.failedLoadPending"), "red");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchResolvedComplaints() {
      this.loading = true;
      const params = {
        status: "RESOLVED",
        page: this.resolvedPagination.page,
        perPage: this.resolvedPagination.rowsPerPage
      };
      
      axios
        .get("booking-complaints", { params })
        .then((res) => {
          this.resolvedComplaints = res.data.data.data || [];
          this.resolvedTotal = res.data.data.total || 0;
        })
        .catch((err) => {
          console.error("Error fetching resolved complaints:", err);
          window.getApp.$emit("SHOW_TOAST", this.$t("ridesListPage.failedLoadResolved"), "red");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openResolveDialog(complaint) {
      this.selectedComplaint = complaint;
      this.resolutionComment = "";
      this.resolveDialog = true;
    },
    closeResolveDialog() {
      this.resolveDialog = false;
      this.selectedComplaint = null;
      this.resolutionComment = "";
    },
    resolveComplaint() {
      if (!this.selectedComplaint) return;
      
      this.resolvingComplaint = true;
      
      axios
        .put(`booking-complaints/${this.selectedComplaint.id}/resolve`, {
          resolution_comment: this.resolutionComment.trim() || null
        })
        .then((res) => {
          window.getApp.$emit("SHOW_TOAST", this.$t("ridesListPage.complaintResolved"));
          this.closeResolveDialog();
          // Refresh both tabs
          this.fetchPendingComplaints();
          if (this.activeTab === 1) {
            this.fetchResolvedComplaints();
          }
        })
        .catch((err) => {
          console.error("Error resolving complaint:", err);
          const message = (err.response && err.response.data && err.response.data.message) || this.$t("ridesListPage.failedResolve");
          window.getApp.$emit("SHOW_TOAST", message, "red");
        })
        .finally(() => {
          this.resolvingComplaint = false;
        });
    },
    goToBooking(bookingId) {
      if (!bookingId) return;
      this.$router.push({ name: "Bookings", params: { id: bookingId } });
    },
    getBookingId(item) {
      return item.booking ? item.booking.id : (item.booking_id || null);
    },
    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("DD/MM/YYYY HH:mm");
    }
  }
};
</script>

<style scoped>
.tab {
  color: #e21024 !important;
}

.booking-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
}

.booking-link:hover {
  color: #1565c0;
}

.tab-content-wrapper {
  touch-action: pan-y !important;
  height: 100%;
  overflow-y: auto;
}
</style>
